angular.module('ecrd', [
    'ecrd.breadcrumbs',
    'ecrd.core',
    'ecrd.notifications',
    'sharecrf.unknown-value',
]).run(['EcrdService', function(EcrdService) {
    EcrdService.registerInitEvents();
}]);
